import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// REDUX Imports
import {
  changePassword,
  resetChangePassword,
  setMultipleEntity,
  setShowReloginModalFalse,
} from "../../../redux/features/login/login";
import {
  xpentraLogout,
  xpentraLogoutSliceReset,
} from "../../../redux/features/logout/logout";
import { logout } from "../../../redux/features/refreshToken/refreshToken";

// UTLIS Imports
import PrimaryLargeButton from "../../../components/_utils/CommonButtons/PrimaryLargeButton";
import PasswordInputField from "../../../components/_utils/CommonInputFields/PasswordInputField";
import CommonToast from "../../../components/_utils/CommonToast";

const ChangePassword = () => {
  // useDispatch
  const dispatch = useDispatch();

  // useNavigate
  const navigate = useNavigate();

  // useState
  const [buttonLoading, setButtonLoading] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [passwordValues, setPasswordValues] = useState({
    currentPasswordValue: "",
    newPasswordValue: "",
    confirmPasswordValue: "",
  });

  // useSelector
  const { changePasswordError, changePasswordErrorMessage } = useSelector(
    (state) => state.login,
  );

  const { xpentraLogoutLoading, xpentraLogoutData, xpentraLogoutError } =
    useSelector((state) => state?.xpentraLogoutSlice);

  // useCallback
  const handleConfirmChangePassword = useCallback(async () => {
    if (
      passwordValues?.currentPasswordValue === "" &&
      passwordValues?.newPasswordValue === "" &&
      passwordValues?.confirmPasswordValue === ""
    ) {
      return;
    } else if (
      passwordValues?.currentPasswordValue?.length > 0 &&
      passwordValues?.newPasswordValue !== passwordValues?.confirmPasswordValue
    ) {
      //to check whether the new password and the confirm password matches.
      setPasswordError(true);
    } else if (
      passwordValues?.currentPasswordValue?.length > 0 &&
      passwordValues?.newPasswordValue?.length > 0 &&
      passwordValues?.confirmPasswordValue?.length > 0
    ) {
      setButtonLoading(true);
      const params = {
        oldPassword: passwordValues?.currentPasswordValue,
        newPassword: passwordValues?.newPasswordValue,
        confirmPassword: passwordValues?.confirmPasswordValue,
        setButtonLoading: setButtonLoading,
      };

      //change the password of logedIn user.
      const response = await dispatch(changePassword(params));

      if (response?.payload?.status) {
        CommonToast({
          text: "Password reset successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        setPasswordValues({
          currentPasswordValue: "",
          newPasswordValue: "",
          confirmPasswordValue: "",
        });
        //User logout API call.
        dispatch(xpentraLogout());
        setButtonLoading(false);
      }
    }
  }, [
    dispatch,
    passwordValues?.confirmPasswordValue,
    passwordValues?.currentPasswordValue,
    passwordValues?.newPasswordValue,
  ]);

  const handleEnterKey = (e, nextRef) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (nextRef && nextRef.current) {
        nextRef.current.focus();
      } else {
        handleConfirmChangePassword();
      }
    }
  };

  // useEffect
  useEffect(() => {
    if (!xpentraLogoutLoading && xpentraLogoutData?.status) {
      //if the user logout successfully { clear all the session storage and user data }
      dispatch(setMultipleEntity());
      dispatch(setShowReloginModalFalse());
      dispatch(logout());
      dispatch(xpentraLogoutSliceReset());
      navigate("/login");
      sessionStorage.clear();
      setButtonLoading(false);
    } else if (
      !xpentraLogoutLoading &&
      !xpentraLogoutData &&
      xpentraLogoutError?.isErrorStatus
    ) {
      //if not check the token of user is valid OR not

      dispatch(xpentraLogoutSliceReset());
      setButtonLoading(false);
    }
  }, [
    xpentraLogoutLoading,
    xpentraLogoutData,
    xpentraLogoutError,
    dispatch,
    navigate,
  ]);

  useEffect(() => {
    document.addEventListener("keydown", handleEnterKey);
    return () => {
      //when component unmount
      if (window.location.pathname !== "/settings/my_profile/change_password") {
        dispatch(resetChangePassword());
      }
      document.removeEventListener("keydown", handleEnterKey);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    handleConfirmChangePassword,
    passwordValues,
    changePasswordError,
    passwordError,
  ]);

  return (
    <>
      {/* My code  */}

      <main
        className="h-full-height flex justify-start Qlg:justify-center items-center gap-gap-xl  flex-col Qlg:flex-row"
        style={{ paddingTop: "var(--navbar-breadcrumb-height)" }}
      >
        {/* Div 1 */}
        <div className="flex flex-col gap-gap-lg items-center">
          {/* Graphics height and width decision pending from designer side */}
          <img
            className="w-[200px] h-[200px]"
            src={
              "https://q2pay.in/new_assets/graphics/login/set_new_password.svg"
            }
            alt="changepassword"
          />
          <div className="flex flex-col gap-gap-xs items-center">
            <h2 className="text-text-primary font-semibold text-font-lg">
              Change password
            </h2>
            <div className="text-center font-normal text-font-sm text-text-primary flex flex-col gap-gap-xs">
              <p>
                Enter current password, then set and confirm your new password.
              </p>
              <p className="text-font-xs">
                Note: You will be logged out and asked to log in again
              </p>
              <p className="text-font-xs">after the password change.</p>
            </div>
          </div>
        </div>
        {/* Div 1 */}

        {/* Div 2 */}
        <article className=" bg-text-primary Qlg:w-change-password-width w-full Qlg:rounded-large rounded-tl-large rounded-tr-large p-padding-xl Qlg:h-change-password-card-height h-full">
          <div className="h-full w-full flex flex-col justify-between">
            <div>
              <div className="flex items-center justify-center pb-padding-lg">
                {/* Graphics height and width decision pending from designer side */}

                <img
                  className="w-[200px] h-[54.92px]"
                  src={
                    "https://q2pay.in/new_assets/xpentra_logo/xpentra_blue.svg"
                  }
                  alt="xpentraLogo"
                />
              </div>
              <div className="flex flex-col gap-gap-md">
                <div className="w-full  flex justify-center  Qlg:justify-start">
                  <p>Set new password</p>
                </div>
                <div className="w-full flex justify-center Qlg:justify-start">
                  <PasswordInputField
                    bgColor="var(--text-primary)"
                    fgColor="var(--primary-bg)"
                    placeholder="Current Password"
                    variant={
                      changePasswordError &&
                      (changePasswordErrorMessage !==
                        "User can not set last password as their current password" ||
                        changePasswordErrorMessage ===
                          "User is unauthorised. Please check your User ID or password")
                        ? "error"
                        : "default"
                    }
                    fontKind="big"
                    value={passwordValues?.currentPasswordValue}
                    onInput={(event) => {
                      setPasswordValues((prev) => {
                        return {
                          ...prev,
                          currentPasswordValue: event.target.value.trim(),
                        };
                      });
                      dispatch(resetChangePassword());
                      setPasswordError(false);
                    }}
                  />
                </div>
                <div className="w-full flex justify-center Qlg:justify-start">
                  <PasswordInputField
                    bgColor="var(--text-primary)"
                    fgColor="var(--primary-bg)"
                    placeholder="New password"
                    variant={passwordError ? "error" : "default"}
                    fontKind="big"
                    value={passwordValues?.newPasswordValue}
                    onInput={(event) => {
                      setPasswordValues((prev) => {
                        return {
                          ...prev,
                          newPasswordValue: event.target.value.trim(),
                        };
                      });
                      dispatch(resetChangePassword());
                      setPasswordError(false);
                    }}
                  />
                </div>
                <div className="w-full flex items-center flex-col Qlg:items-start">
                  <PasswordInputField
                    bgColor="var(--text-primary)"
                    fgColor="var(--primary-bg)"
                    placeholder="Confirm password"
                    variant={passwordError ? "error" : "default"}
                    fontKind="big"
                    value={passwordValues?.confirmPasswordValue}
                    onInput={(event) => {
                      setPasswordValues((prev) => {
                        return {
                          ...prev,
                          confirmPasswordValue: event.target.value.trim(),
                        };
                      });
                      dispatch(resetChangePassword());
                      setPasswordError(false);
                    }}
                  />
                  <p
                    className="text-failed text-xs font-semibold mt-margin-xs  w-full h-full  cursor-default min-w-input-min-width  max-w-input-max-width"
                    style={{ visibility: passwordError ? "visible" : "hidden" }}
                  >
                    The passwords do not match.
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-auto w-full flex justify-center Qlg:justify-start">
              <PrimaryLargeButton
                btnType="button"
                btnText="Change password"
                hoverOption="black"
                enabledBgColor="var(--positive-act)"
                enabledTextColor="var(--text-primary)"
                disabledBgColor="var(--text-disabled)"
                disabledTextColor="var(--text-primary)"
                isDisabled={
                  buttonLoading ||
                  changePasswordError ||
                  passwordError ||
                  !passwordValues?.confirmPasswordValue ||
                  !passwordValues?.newPasswordValue ||
                  !passwordValues?.confirmPasswordValue
                }
                handleFunction={(e) => {
                  handleConfirmChangePassword(e);
                }}
                isLoaderNeeded={true}
                isLoading={buttonLoading}
              />
            </div>
          </div>
        </article>
        {/* Div 2 */}
      </main>

      {/* My code  */}
    </>
  );
};

export default ChangePassword;
